/* eslint-disable import/no-cycle */
/* eslint-disable no-useless-constructor */
/* eslint-disable class-methods-use-this */
import { pipeline } from '..';
import { LVT_METRIC_CHECKOUT_ANALYSIS_STORAGE_KEYS } from '../../constants';
import { TrackingPrimitives } from './primitives';

class TrackingPipeline {
  constructor(public primitives: TrackingPrimitives) {}

  markWebsiteAsClosed(): void {
    // TODO(dark-launch): remove 'if' after metrics dark launch strategies would be over
    if (window.location.origin !== 'https://stage.rbo.org.uk') return;

    localStorage.setItem(
      LVT_METRIC_CHECKOUT_ANALYSIS_STORAGE_KEYS.closedWebsiteAt,
      Date.now().toString()
    );
  }

  checkIfSessionIsAbandoned(): void {
    // TODO(dark-launch): remove 'if' after metrics dark launch strategies would be over
    if (window.location.origin !== 'https://stage.rbo.org.uk') return;

    const startCheckoutTime = Number(
      pipeline.storage.getLocalStorageItem('startCheckoutTime')
    );
    const closedWebsiteAt = Number(
      pipeline.storage.getLocalStorageItem('closedWebsiteAt')
    );
    if (!closedWebsiteAt || !startCheckoutTime) return;

    const now = Date.now();
    const hour = 3600000; // 1 hour

    if (closedWebsiteAt - startCheckoutTime < hour) return;
    if (now - startCheckoutTime < hour) return;

    this.primitives.abandoned();
  }

  listenForEvents(): void {
    // TODO(dark-launch): remove 'if' after metrics dark launch strategies would be over
    if (window.location.origin !== 'https://stage.rbo.org.uk') return;

    this.primitives.listenForFeatures('schools_cpd_events');
  }
}

const primitives = new TrackingPrimitives();
export const trackingPipeline = new TrackingPipeline(primitives);
